/**
 * Helpers de contato rápido (F4 — discagem, WhatsApp, LinkedIn em um clique).
 * Funções puras: sem React, testáveis isoladamente.
 */

/** Só os dígitos do telefone. */
export function digitos(valor) {
    return String(valor || '').replace(/\D/g, '');
}

/**
 * Normaliza para E.164 brasileiro sem o "+": 55 + DDD + número.
 * Retorna '' quando o número não tem 10 ou 11 dígitos (sem DDI) nem 12/13 (com 55).
 */
export function telefoneE164(valor) {
    let d = digitos(valor);
    if (d.startsWith('00')) d = d.slice(2);
    if (d.startsWith('0') && (d.length === 11 || d.length === 12)) d = d.slice(1); // 0 + DDD (discagem longa distância)
    if ((d.length === 12 || d.length === 13) && d.startsWith('55')) return d;
    if (d.length === 10 || d.length === 11) return '55' + d;
    return '';
}

/** Celular brasileiro: 9 dígitos começando com 9 depois do DDD. */
export function ehCelular(valor) {
    const e = telefoneE164(valor);
    return e.length === 13 && e.charAt(4) === '9';
}

/** Link tel: — funciona no softphone/celular do assessor. */
export function linkTel(valor) {
    const e = telefoneE164(valor);
    return e ? `tel:+${e}` : '';
}

/** Link do WhatsApp (abre o app ou o WhatsApp Web). */
export function linkWhatsApp(valor, texto) {
    const e = telefoneE164(valor);
    if (!e) return '';
    return `https://wa.me/${e}` + (texto ? `?text=${encodeURIComponent(texto)}` : '');
}

/** Garante URL absoluta para o LinkedIn (aceita "linkedin.com/in/x", "/in/x" ou "x"). */
export function linkLinkedin(valor) {
    const v = String(valor || '').trim();
    if (!v) return '';
    if (/^https?:\/\//i.test(v)) return v;
    if (/linkedin\.com/i.test(v)) return 'https://' + v.replace(/^\/+/, '');
    if (v.startsWith('/in/') || v.startsWith('in/')) return 'https://www.linkedin.com/' + v.replace(/^\/+/, '');
    if (/^[\w\-%.]+$/.test(v)) return 'https://www.linkedin.com/in/' + v;
    return '';
}

export function linkEmail(valor) {
    const v = String(valor || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? `mailto:${v}` : '';
}

/** Exibe o telefone no formato (11) 91234-5678. */
export function formatarTelefone(valor) {
    let d = digitos(valor);
    if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2);
    if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    return String(valor || '');
}

/** Copia para a área de transferência; cai para execCommand em HTTP (homologação sem TLS). */
export async function copiarTexto(texto) {
    const t = String(texto || '');
    if (!t) return false;
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(t);
            return true;
        }
    } catch (e) { /* segue para o fallback */ }
    try {
        const area = document.createElement('textarea');
        area.value = t;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(area);
        return ok;
    } catch (e) {
        return false;
    }
}
